import React, { lazy, Suspense } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useNavV5 } from "@/features/accountNavV5/lib/useNavV5";
import { streamsFallbackTarget } from "@/pages/StreamsPage/lib/streamsLinks";

/*
 * /:lang/account/streams — «Эфиры», пока только администраторам (владелец,
 * 11.10: эфиры убраны с «Моих лекций» на свою вкладку, «которая пока должна
 * быть видна только админам»). Страница — внутри кабинета (ребёнок account,
 * вход проверяет RequireAuth), а здесь решается только, кому она открыта:
 *   администратор                                → «Эфиры»;
 *   остальные (и админ «как обычный пользователь») → «Мои лекции», с заменой
 *                                                   записи, без эфирных параметров;
 *   список администраторов ещё грузится            → пусто (решать не из чего).
 * Тот же признак, что у меню и ряда разделов (useNavV5): кому пункта не
 * видно, тому и страницы нет.
 */

const StreamsPage = lazy(() => import("@/pages/StreamsPage/ui/StreamsPage"));

export const StreamsRoute: React.FC = () => {
    const { lang = "ru" } = useParams<{ lang: string }>();
    const { search } = useLocation();
    const { enabled: admin, loading } = useNavV5();
    if (loading) return <div data-testid="streams-checking" />;
    if (!admin) return <Navigate to={streamsFallbackTarget(lang, search)} replace />;
    return (
        <Suspense fallback="">
            <StreamsPage />
        </Suspense>
    );
};

export default StreamsRoute;
